import { Injectable, EventEmitter } from '@angular/core';
import { DATE_FIELD_OPTIONS } from '../../common/constants/date-field.constants';

@Injectable({
  providedIn: 'root'
})
export class DateFieldService {

  selectedDateField: string = (DATE_FIELD_OPTIONS[0]?.id);
  dateFieldSelectionChanged = new EventEmitter<string>();
  private readonly _storageKey = 'alertsSelectedDateField';

  private readonly _allowedFieldIds = new Set([
    'lastActiveTo',
    'createdTime',
    'lastSystemUpdate',
    'lastUserUpdate',
    'confirmedTime'
  ]);

  constructor() {
    const storedValue = localStorage.getItem(this._storageKey);
    const initial = this._allowedFieldIds.has(storedValue) ? storedValue : this.selectedDateField;
    this.selectedDateField = initial;
  }

  setSelectedDateField(fieldId: string, emitChange: boolean = true): void {
    const next = this._allowedFieldIds.has(fieldId) ? fieldId : (DATE_FIELD_OPTIONS[0]?.id);
    if (next === this.selectedDateField) {
      return;
    }
    this.selectedDateField = next;
    localStorage.setItem(this._storageKey, this.selectedDateField);
    if (emitChange) {
      this.dateFieldSelectionChanged.emit(next);
    }
  }

  getSelectedDateField(): string {
    return this.selectedDateField;
  }

  getFilterFieldName(fieldId: string): string {
    return fieldId || (DATE_FIELD_OPTIONS[0]?.id);
  }
}
